import React from "react";
import { useSelector } from "react-redux";
import CurrentPlan from "./CurrentPlan";
import NewCurrentPlan from "./NewCurrentPlan";
const RoleBasedPlanScreen = () => {
  const userInfo = useSelector((state) => state.auth.userInfo);

  if (!userInfo) return <div>Loading...</div>;

  const roleId = Number(userInfo.role);
  if(roleId==1)
  {
    return <CurrentPlan/>
  }
  else
  {
    return <NewCurrentPlan/>
  }
};

export default RoleBasedPlanScreen;
